import { gql } from '@apollo/client';

export const UploadContentImage = gql`
  mutation UploadContentImage(
    $accommodationObjectCid: String!
    $section: String!
    $attachment: Upload!
    $sectionObjectName: String
  ) {
    UploadContentImage(
      input: {
        AccommodationObjectCid: $accommodationObjectCid
        Section: $section
        SectionObjectName: $sectionObjectName
        Attachment: $attachment
      }
    ) @rest(type: "File", path: "/ContentService/upload-file", method: "POST", bodySerializer: "fileEncode") {
      fileId
      fileName
      fileSize
      errors {
        ...Error
      }
    }
  }
`;

export const GetContentServicImage = gql`
  query GetContentServicImage(
    $fileId: String!
    $section: String!
    $sectionObjectName: String
    $accommodationObjectCid: String!
  ) {
    GetContentServicImage(
      fileId: $fileId
      section: $section
      sectionObjectName: $sectionObjectName
      accommodationObjectCid: $accommodationObjectCid
    ) @rest(path: "/ContentService/download-file?{args}", method: "GET") {
      data
      errors {
        ...Error
      }
    }
  }
`;

export const DeleteContentImage = gql`
  mutation DeleteContentImage(
    $fileId: String!
    $section: String!
    $sectionObjectName: String
    $accommodationObjectCid: String!
  ) {
    DeleteContentImage(
      fileId: $fileId
      section: $section
      sectionObjectName: $sectionObjectName
      accommodationObjectCid: $accommodationObjectCid
    ) @rest(type: "Item", path: "/ContentService/delete-file?{args}", method: "DELETE") {
      errors {
        ...Error
      }
    }
  }
`;
